import React from 'react'

/**
 * Suspense fallback for the top-level lazy routes. Kept dependency-light and free of app
 * providers (IntlProvider, TailwindContext, …) on purpose: these Suspense boundaries sit
 * above the providers, so it must render before any of them mount.
 */
export default function AppLoading () {
  return (
    <div className="flex items-center justify-center min-h-screen" role="status" aria-label="Loading">
      <div className="w-14 h-14 border-8 border-t-8 rounded-full animate-spin border-gray-light border-t-primary" />
    </div>
  )
}
